import i18n from "../../../../i18n";

export const validateImage = imageFile => {
    if (imageFile && imageFile.length > 0) {
      const types = ['image/jpeg', 'image/png']
      const imageFileKb = imageFile[0].size / 1024 / 1024;
      const imageType = types.includes(imageFile[0].type);
  
      if (imageFileKb > 0.5) {
        return i18n.t("products.maxPhotoSize");
      }
  
      if (!imageType) {
        return i18n.t("products.unsupportedImageFormat");
      }
  
      return undefined;
    }
  }

  export const size = e => e ? e.length > 0 ? e[0].size/1024/1024 < 0.5 ? undefined : i18n.t("products.maxPhotoSize") : undefined : undefined;
  export const trim = (str, count) => str.length > count ? str.slice(0, count) + '…' : str;
